import { Component } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'klickitlanding-app';
  showLayout = false;

  constructor(private router: Router) {
    this.showLayout = this.shouldShowLayout(this.router.url);

    this.router.events.pipe(
      filter((event): event is NavigationStart | NavigationEnd =>
        event instanceof NavigationStart || event instanceof NavigationEnd
      )
    ).subscribe((event) => {
      const url = event instanceof NavigationEnd ? event.urlAfterRedirects : event.url;
      this.showLayout = this.shouldShowLayout(url);
    });
  }

  private shouldShowLayout(url: string): boolean {
    return !url.includes('/onboarding') && !url.startsWith('/developers');
  }
}
